/* eslint-disable no-unused-expressions */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-shadow */
import React from "react";
import moment from "moment";
import { connect } from "react-redux";
import Hidden from "@material-ui/core/Hidden";
import { ButtonToolbar } from "react-bootstrap";

import GridList from "../collection/GridList";
import { PageWrapper } from "../../../shared/layout";
import { CityWiseId, roles } from "../../../lib/constants";
import { templateStrings } from "../../../Constant";
import OperatorViewVehicleList from "./OperatorViewVehicleList";
import { style2 as useStyles } from "../../../styles/makeStyles";
import NavFilter from "../../../shared/widgets/navFilter/navFilter";
import { selectDateFilter } from "../../../redux/actions/dateFilterAction";
import { selectedOperationType } from "../../../redux/actions/operationTypeAction";
import { collectionSummaryAction } from "../../../redux/action-creators/collectionActionCreator";
import {
  Tabs,
  BarLoader,
  Search as SearchBar,
  Button,
  RangePicker,
} from "../../../shared/widgets";
import { exportExcel } from "../../../shared/utils";

const determineGridItems = (
  content,
  gridLoader,
  user,
) => {
  const gridItemsData = content;
  const loader = gridLoader;
  let type = "operatorViewGridItems";
  let gridStrings = templateStrings.operatorViewGridItems;
  if (user?.role && user.role === "AgencyManager") {
    gridStrings = templateStrings.agencyViewGridItems;
    type = "agencyViewGridItems";
  }
  if (
    user.role === roles.agencyManager && user?.cityIds?.includes(CityWiseId.Mumbai)

  ) {
    gridStrings = JSON.parse(JSON.stringify(gridStrings));
    delete gridStrings.averageBuses;
  }
  return {
    gridItemsData, loader, gridStrings, type,
  };
};

function CollectionList(props) {
  const {
    selectedOperationType: selectedOperationTypeProp,
    operatorFilter, cityFilter, selectedDateFilter, selectedOperation,
    fetchCollectionSummary, content, gridLoader, user, operationType,
    selectDateFilter: selectDateFilterCallback,
  } = props;
  const classes = useStyles();

  const [value, setValue] = React.useState("vehicle");
  const [searchString, setSearchString] = React.useState("");
  const [operationHeader, setOperationHeader] = React.useState("All");
  const [selectOperationList, setSelectOperationList] = React.useState([]);

  React.useEffect(() => {
    selectedOperationTypeProp("");
  }, []);

  React.useEffect(() => {
    fetchCollectionSummary(
      {
        operatorFilter,
        cityFilter,
        dateFilter: selectedDateFilter,
        operationType: selectedOperation,
      },
      "gridLoader",
    );
  }, [
    operatorFilter,
    cityFilter,
    selectedDateFilter,
    selectedOperation,
  ]);

  const handleDatesChange = (dates) => {
    if (dates.startDate && dates.endDate) {
      const fromDate = parseFloat(new Date(dates.startDate).getTime());
      const toDate = parseFloat(new Date(dates.endDate).getTime());
      selectDateFilterCallback({ fromDate, toDate });
    }
  };

  const handleSearchChange = (e) => {
    setSearchString(e);
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleOperationTypeSelection = async (operationTypeProp) => {
    if (operationTypeProp === "All") {
      selectedOperationTypeProp("");
    } else {
      selectedOperationTypeProp(operationTypeProp);
    }
  };

  const exportCollection = async () => {
    const id = "exportCollectionData";
    const addOnFilter = {
      cityIdArr: cityFilter || [],
      operatorIdArr: operatorFilter || [],
      date: selectedDateFilter || "",
      operationType: selectedOperation || "",
    };
    await exportExcel({ id, addOnFilter });
  };

  const setHeader = (source, header) => {
    source === "operationType" && setOperationHeader(header);
  };

  const setSelected = (source, data) => {
    source === "operationType" && setSelectOperationList(data);
  };

  const {
    gridItemsData, loader, gridStrings, type,
  } = determineGridItems(
    content,
    gridLoader,
    user,
  );

  return (
    <div className={classes.root}>
      <PageWrapper>
        <Hidden only={["lg", "md", "xl"]}>
          <div className={classes.picker}>
            <RangePicker
              startDate={moment(new Date(props?.selectedDateFilter?.fromDate))}
              endDate={moment(new Date(props?.selectedDateFilter?.toDate))}
              onDatesChange={handleDatesChange}
              monthsToDisplay={1}
            />
          </div>
        </Hidden>
        <PageWrapper.Header heading="Overview" hideS>
          <div className="pull-right">
            <NavFilter
              source="operationType"
              options={operationType}
              selected={selectOperationList}
              setSelected={setSelected}
              setHeader={setHeader}
              filterHeader={operationHeader || "All"}
              onMenuSelection={handleOperationTypeSelection}
            />
          </div>
          <Hidden only={["sm", "xs"]}>
            <div className="pull-right">
              <Button
                onClick={() => {
                  exportCollection();
                }}
                buttonText="Export"
              />
            </div>
            <div className="pull-right z-index-10">
              <ButtonToolbar>
                <RangePicker
                  startDate={moment(
                    new Date(selectedDateFilter.fromDate),
                  )}
                  endDate={moment(new Date(selectedDateFilter.toDate))}
                  onDatesChange={handleDatesChange}
                  monthsToDisplay={1}
                />
              </ButtonToolbar>
            </div>
          </Hidden>
        </PageWrapper.Header>
        <PageWrapper.Body>
          <div className="custom-grid-layout">
            {Object.keys(gridStrings).map((column, index) => (
              <div key={index} className="custom-grid">
                <GridList
                  value={gridItemsData[column]}
                  isLoading={loader}
                  gridItemsData={gridItemsData}
                  template={column}
                  type={type}
                />
              </div>
            ))}
          </div>
          <div>
            <PageWrapper.Header hideS removeFilterOnly isHeaderFixed={false}>
              <div className="dataTables_length tabWrapper">
                <Tabs
                  tabs={[{ key: "vehicle", display: "Vehicle Wise" }]}
                  activeTab={value}
                  onTabSelection={(key) => {
                    handleChange("true", key);
                  }}
                />
              </div>
              <Hidden only={["lg", "xl", "md"]}>
                <div className="tabWrapper">
                  {value && value === "vehicle" && (
                    <SearchBar
                      placeHolder="Search Vehicle"
                      onSearchChange={(e) => {
                        handleSearchChange(e);
                      }}
                    />
                  )}
                </div>
              </Hidden>
              <Hidden only={["sm", "xs"]}>
                <div className="pull-right search-container">
                  {value && value === "vehicle" && (
                    <SearchBar
                      placeHolder="Search Vehicle"
                      onSearchChange={(e) => {
                        handleSearchChange(e);
                      }}
                    />
                  )}
                </div>
              </Hidden>
            </PageWrapper.Header>
          </div>
          <div>
            <BarLoader scope="header" />
            {value === "vehicle" ? (
              <OperatorViewVehicleList searchString={searchString} />
            ) : null}
          </div>
        </PageWrapper.Body>
      </PageWrapper>
    </div>
  );
}

function mapStateToProps(state) {
  return {
    content: state.Collection.collectionSummary,
    cityFilter: state.Cities.selectedCity,
    operatorFilter: state.Operators.selectedOperator,
    selectedDateFilter: state.DateFilter.selectedDateFilter,
    user: state.Auth.user,
    gridLoader: (state && state.loadingBar && state.loadingBar.gridLoader),
    operationType: state.OperationType.operationType,
    selectedOperation: state.OperationType.selectedOperationType,
  };
}

const mapDispatchToProps = (dispatch) => ({
  fetchCollectionSummary: (params, loaderScope) => {
    dispatch(collectionSummaryAction(params, loaderScope));
  },
  selectDateFilter: (value) => {
    dispatch(selectDateFilter(value));
  },
  selectedOperationType: (params) => {
    dispatch(selectedOperationType(params));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(CollectionList);
